export const Work = [
  {
    id: 1,
    name: "React Simple Movie",
    description:
      "It is built on top of the React JS, with Tailwind and fetching TMDB API.",
    tags: ["react", "tailwind", "api", "sass", "react-router"],

    demo: "https://dmovie-six.vercel.app/",
    github: "https://github.com/Hvdodeptrai/react-simple-movie",
  },
  {
    id: 2,
    name: "Github Profile App",
    description:
      "A Github profile app is constructed by fetching all api of github users, beautiful UI.",
    tags: ["javascript", "sass", "api"],

    demo: "https://gihub-profile-app.vercel.app/",
    github: "https://github.com/Hvdodeptrai",
  },
  {
    id: 3,
    name: "Flappy Bird Clone",
    description:
      "A clone of most once famous game - Flappy Bird with only 50 lines of code.",
    tags: ["javascript", "vanilla", "css"],

    demo: "https://flappy-bird-theta.vercel.app/",
    github: "https://github.com/Hvdodeptrai/Flappy-bird",
  },
  {
    id: 4,
    name: "First Portfolio",
    description:
      "A first and cool portfolio with some animations and also responsive.",
    tags: ["html", "css", "grid-layout"],

    demo: "https://technophile1603.herokuapp.com/about.html",
    github: "https://github.com/Hvdodeptrai/Portfolio-demo",
  },
  {
    id: 5,
    name: "Todo App(React + Redux)",
    description:
      "A todo app build using Redux-toolkit and framer-motion for smooth animations.",
    tags: ["react", "redux", "framer-motion"],

    demo: "http://react-redux-todo-app-git-main-codebucks27.vercel.app/",
    github: "https://github.com/codebucks27/React-Redux-Todo-App",
  },
  {
    id: 6,
    name: "Responsive Navigation Menu",
    description:
      "A reponsive navbar menu component in ReactJS with react-router functionalities. Built from scratch.",
    tags: ["react", "react-router", "css"],

    demo: "http://react-responsive-navbar-codebucks27.vercel.app/",
    github: "https://github.com/codebucks27/React-responsive-navbar",
  },
];
